import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=454b9939&scoped=true"
import script from "./CharacterList.vue?vue&type=script&lang=ts"
export * from "./CharacterList.vue?vue&type=script&lang=ts"
import style0 from "./CharacterList.vue?vue&type=style&index=0&id=454b9939&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b9939",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454b9939')) {
      api.createRecord('454b9939', component.options)
    } else {
      api.reload('454b9939', component.options)
    }
    module.hot.accept("./CharacterList.vue?vue&type=template&id=454b9939&scoped=true", function () {
      api.rerender('454b9939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CharacterList.vue"
export default component.exports